export default function ({ $auth, redirect, app }) {
  // console.debug('[isUserOrNot.js] (if) $auth.user  (then) return redirect(\'/users\') (else) return redirect(\'/login\')')
  if ($auth.user) {
    return redirect(app.localePath('/users'))
  }else{
    return redirect(app.localePath('/login'))
  }
}
